import {
	configureStore, createAsyncThunk as createAsyncThunkBase, type DevToolsEnhancerOptions,
	type EnhancedStore, type Reducer, type StoreEnhancer, type Tuple, type UnknownAction, type ThunkDispatch,
	buildCreateSlice, asyncThunkCreator
} from "@reduxjs/toolkit";
import {
	type TypedUseSelectorHook, useSelector as reduxUseSelector, useDispatch as reduxUseDispatch
} from "react-redux";
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE } from "redux-persist";
import type { AppState } from "Data/Redux/Reducers";

export type ThunkApiConfig = { state: AppState };

export let store: EnhancedStore<AppState, UnknownAction, Tuple<[StoreEnhancer<{
	dispatch: ThunkDispatch<AppState, undefined, UnknownAction>; }>, StoreEnhancer]>>;

export const buildStore = (reducer: Reducer, devTools: DevToolsEnhancerOptions) => {
	store = configureStore({
		reducer: reducer,
		devTools,
		middleware: (getDefaultMiddleware) => getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: [ FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER ]
			}
		})
	});
};

export const createAsyncThunk = createAsyncThunkBase.withTypes<ThunkApiConfig>();
export const useAppSelector: TypedUseSelectorHook<AppState> = reduxUseSelector;
export const useAppDispatch: () => typeof store.dispatch = reduxUseDispatch;
export const createAppSlice = buildCreateSlice({
	creators: { asyncThunk: asyncThunkCreator }
});
